module.exports = __webpack_public_path__ + "img/american_express_white.9a8103fb.svg";